import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-forms-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfFormsIconProps extends SvgIconProps {}

/**
 *
 * @param props - CcfFormsIcon
 * @example <CcfFormsIcon />
 * @returns
 */
export function CcfFormsIcon(props: CcfFormsIconProps) {
  return (
    <SvgIcon
      // width="20"
      // height="20"
      // viewBox="0 0 20 20"
      // fill="none"
      {...props}
    >
      <path
        d="M17 16.5C17 17 17 18 16.5 18H3.5C3 18 2 16.4 2 15.9V3.50002C2 3.00002 3 3.00002 3.5 3.00002H11V1.00002H3.5C1.5 1.00002 0 1.50002 0 3.50002V16.5C0 18 1.5 20 3.5 20H16.5C18.5 20 19 18.5 19 16.5V11H17V16.5Z"
        fill="#FF9400"
      />
      <path
        d="M7.5 13H10.1L19.5 2.60002L17 0.400024L7.5 10.6V13Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfFormsIcon;
